module.exports = __webpack_public_path__ + "static/media/meeting.ab95767e.jpg";